import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { appEnvType } from "./utils/consts";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
if (process.env.REACT_APP_MODE === appEnvType.production) {
  console.log = function () {};
}
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
